import React, { useEffect, useRef, useState } from "react";
import API from "../../../api";



export default {
    makeImageUrl: (dirPath:string, imgName:string) => {
      const S3_PREFIX = "https://nmodelin20.s3.ap-northeast-2.amazonaws.com";
      return `${S3_PREFIX}/${dirPath}/${imgName}`;
    },

    getUrlText: (url: string) => {
      if (!url) return "";

      if (url.startsWith("http")) {
        return url;
      } else {
        return `https://${url}`;
      }
    },

    onLinkClick: (url: string) => {
      const targetLink = url.startsWith("http") ? url : `http://${url}`;
      window.open(targetLink, "_blank");
    },

    showBsProductUrlEditModal: (props, bsProductId, onOkFunc, title, text) => {
      props.showModal({
        title,
        text,
        input: {
          type: "text",
          placeholder: "https://",
        },
        cancel: () => {},
        confirm: (url) => {
            API.BrandSns.updateBsProductUrl({
              brandToken: props.auth.token,
              bsProductId,
              url,
            })
            .then(async (response) => {
              await onOkFunc(response);
            })
            .catch((error) => {
              throw error;
            });
        },
      });
    },


    // deprecated. only for celeb
    showCelebProductUrlEditModal: (props, productId, onOkFunc, title, text) => {
      props.showModal({
        title,
        text,
        input: {
          type: "text",
          placeholder: "https://",
        },
        cancel: () => {},
        confirm: (url) => {
            API.BrandSns.updateCelebProductUrl({
              brandToken: props.auth.token,
              productId,
              url,
            })
            .then(async (response) => {
              await onOkFunc(response);
            })
            .catch((error) => {
              throw error;
            });
        },
      });
    },
}
